import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatTableModule } from '@angular/material/table';

import { SharedModule } from 'src/app/components/shared/shared.module';
import { SharedReportsModule } from '../../shared/shared-reports.module';
import { CollectedComponent } from './collected/collected.component';
import { GroupCodExtractComponent } from './group-cod-extract/group-cod-extract.component';
import { OutForDeliveryComponent } from './out-for-delivery/out-for-delivery.component';
import { ReconcileReportComponent } from './reconcile-report/reconcile-report.component';
import { ReconcilePopupComponent } from './reconcile/reconcile-popup/reconcile-popup.component';
import { ReconcileComponent } from './reconcile/reconcile.component';
import { OutstandingComponent } from './outstanding/outstanding.component';

@NgModule({
  declarations: [
    CollectedComponent,
    GroupCodExtractComponent,
    OutForDeliveryComponent,
    ReconcileReportComponent,
    ReconcileComponent,
    ReconcilePopupComponent,
    OutstandingComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    SharedReportsModule,
    MatTableModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CodReportsModule {}
